<template>
  <template v-for="node in nodes" :key="node.key">
    <component 
      :is="getComponent(node.component)" 
      v-bind="node.props"
    >
      <template v-if="node.children && node.children.length > 0">
        <RichTextRenderer :nodes="node.children" />
      </template>
      <template v-else>{{ node.text || '' }}</template>
    </component>
  </template>
</template>

<script setup lang="ts">
import ResponsiveImage from './ResponsiveImage.vue'

interface RenderedNode {
  component: string
  props: Record<string, any>
  text?: string
  children?: RenderedNode[]
  key: number
}

defineProps<{
  nodes: RenderedNode[]
}>()

// Map component names to actual components
const componentMap: Record<string, any> = {
  ResponsiveImage
}

const getComponent = (componentName: string) => {
  return componentMap[componentName] || componentName
}
</script> 